import { render, staticRenderFns } from "./RunServerScript.vue?vue&type=template&id=60336f32&scoped=true&"
import script from "./RunServerScript.vue?vue&type=script&lang=ts&"
export * from "./RunServerScript.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60336f32",
  null
  
)

export default component.exports